import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { ListError } from "@tenant/ui";
import clsx from "clsx";
import { useFetchFlights } from "../../hooks";
import defaultStyles from "./FlightListError.module.scss";

export type FlightListErrorProps = PlatformComponentProps & {
  onErrorReload: () => void;
};
export const FlightListError = ({
  className,
  children,
  onErrorReload,
}: FlightListErrorProps) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightListError;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block] = useModuleBEM(styles, COMPONENT_KEY);

  return (
    <ListError className={clsx(block, className)} onTapReload={onErrorReload}>
      {children}
    </ListError>
  );
};
